import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ListResponse } from '@daikin-tic/dxone-com-lib';

import { Model, ModelQueryParams, ModelsCreateParams, ModelsExtract, ModelsExtractParams } from '../models/model.model';
import { ModelGateway } from '../usecases/model.gateway';

@Injectable()
export class ModelService extends ModelGateway {
  constructor(private _http: HttpClient) {
    super();
  }

  listModels(params: ModelQueryParams): Observable<ListResponse<Model>> {
    return this._http.get<ListResponse<Model>>('api/vgs/models', { params });
  }

  listExtractModels(params: ModelsExtractParams): Observable<ListResponse<ModelsExtract>> {
    return this._http.post<ListResponse<ModelsExtract>>('api/vgs/models/extract', params);
  }

  createModels(params: ModelsCreateParams): Observable<ListResponse<Model>> {
    return this._http.post<ListResponse<Model>>('api/vgs/models', params);
  }

  deleteModel(modelId: string): Observable<void> {
    return this._http.delete<void>(`api/vgs/models/${modelId}`);
  }
}
